/* import __COLOCATED_TEMPLATE__ from './ecommerce-state.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { AiContentState } from 'embercom/lib/ai-content-library/constants';
import { type FolderCounts } from 'embercom/lib/content-service/search-api';

interface EcommerceStateSignature {
  Args: {
    ecommerceStates: AiContentState[];
    fingested?: boolean;
    folderCounts?: FolderCounts;
  };
}

export default class EcommerceState extends Component<EcommerceStateSignature> {
  stateWhenUsed = AiContentState.USED_BY_FIN;

  get hasStates(): boolean {
    return this.args.ecommerceStates && this.args.ecommerceStates.length > 0;
  }

  // returning true since there isn't any pre-condition for success state
  get preCondition(): boolean {
    return true;
  }

  get isIngesting(): boolean {
    return this.args.ecommerceStates.length === 1 &&
      this.args.ecommerceStates[0] === this.stateWhenUsed &&
      this.args.fingested !== undefined
      ? !this.args.fingested
      : false;
  }

  get hasFolderCounts(): boolean {
    return !!this.args.folderCounts;
  }

  get ecommerceEnabledCount(): number {
    return this.args.folderCounts?.chatbot_enabled ?? 0;
  }

  get totalCount(): number {
    return this.args.folderCounts?.status_counts?.total ?? 0;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Table::Cells::EcommerceState': typeof EcommerceState;
    'knowledge-hub/filterable-list/table/cells/ecommerce-state': typeof EcommerceState;
  }
}
